/* Final-polish enhancement: slideshow image-error guard. */
(function () {
  'use strict';

  /* 1) Hero guard: a slideshow image that fails mid-load can leave Flickity with a
     wrongly measured (locked) height. Nudge a re-measure when that happens. */
  function heroGuard() {
    var imgs = document.querySelectorAll('.section-slideshow .slideshow__slide-bg img');
    Array.prototype.forEach.call(imgs, function (img) {
      var nudge = function () {
        setTimeout(function () { window.dispatchEvent(new Event('resize')); }, 60);
      };
      if (img.complete && img.naturalWidth === 0) nudge();
      img.addEventListener('error', nudge);
    });
  }

  function init() { heroGuard(); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
